import { ApiResponse, handleApiCall } from "./api";
import { osTypes, paces, profiles, Progress } from "src/interfaces/course";


export async function getProgress(adminUID: string): Promise<ApiResponse<Progress>> {

    return await handleApiCall<Progress>('get', 'v2/course', { query: `?uid=${adminUID}` });
}

export async function setProfile(adminUID: string, profile: profiles, osType: osTypes, pace?: paces): Promise<ApiResponse<void>> {

    return await handleApiCall<void>('put', 'v2/profile', { body: {uid: adminUID, profile, osType, pace} });
}

export async function setProgress(adminUID: string, submodule: string): Promise<ApiResponse<void>> {

    return await handleApiCall<void>('put', 'v2/course', { body: {uid: adminUID, submodule} });
}
